<template>
    <div class="h-100" style="display: flex;flex-direction: column;">
        <div style="border-bottom: 1px solid #1e1e1e;padding:8px 0px 0px 0px;" class="filter-fields-in-asset w-100">
            <div class="search-bar-comm-style comm-div" style="float:inline-start;height: 38px; padding: 0px !important;  display: inline-flex;margin-inline-start: 5px;">
                <div class="filter-wrapper selected-filter comm-div">
                    <label style="max-width:17% !important">{{$t('User')}} </label>
                    <div class="user-filter" style="width:100%">
                        <UserMultiSelect
                            id="user-filters"
                            ref="UserMultiSelect"
                            :isSearchable="true"
                            :enableCheckbox="false"
                            :enableAllOption="true"
                            @updatedUsersList="handleUpdatedUsersList" 
                            :selectedUserIdList="(selectedUserInfo)?selectedUserInfo._id:[]"
                        >
                        </UserMultiSelect>
                    </div>
                    <div style="width:22px;margin-inline-end: 7px;">
                        <svg v-if="selectedUserInfo" @click="selectedUserInfo = null;fetchReportsQuery(true)"
                            width="2em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-x" style="height: 30px; color: rgb(169, 169, 169); width: 30px;margin-inline-end: 3px;">
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                            </path>
                        </svg>
                        <svg v-else-if="!selectedUserInfo || !('_id' in selectedUserInfo)"
                            @click="focusMultiSelect('user-filters')" xmlns="http://www.w3.org/2000/svg" style="margin-inline-end: 7px;" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-caret-down-fill icon-background-on-hover">
                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z">
                            </path>
                        </svg>
                    </div>
                </div>
                <!-- <div class="filter-wrapper selected-filter comm-div">
                    <label style="min-width:33% !important">{{$t('Created On')}} :</label>
                    <template v-if="selectedCreatedDateValue && selectedCreatedDateValue.value_id && ['after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)">
                        <span style="color: #f8f9fa!important;margin-inline-start: 6px;max-width: 55px;" :style="selectedCreatedDateValue.value_id == 'before_date'?'width: 54px':''">{{selectedCreatedDateValue.value}} - </span>
                    </template>
                    <DatePicker
                        id="created_on"
                        ref="createdOn"
                        v-if="selectedCreatedDateValue.value_id == 'range'"
                        range
                        v-model="createdOnFilter"
                        :title="createdOnFilter"
                        valueType="format"
                        @input="fetchReportsQuery(true)"
                        @clear="selectedCreatedDateValue = {}"
                        placeholder='Select Date'
                        class="bg-transparent rounded  text-light"
                        style="height:37px !important;width:calc(100% - 45px) !important;top: 7px;margin-inline-start: 4px;" 
                    ></DatePicker>
                    <DatePicker
                        id="created_on_non_range"
                        ref="createdOnNonRange"
                        v-else-if="['after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)"
                        :range="false"
                        v-model="createdOnFilter"
                        :title="createdOnFilter"
                        valueType="format"
                        @input="fetchReportsQuery(true)"
                        @clear="selectedCreatedDateValue = {}"
                        placeholder='Select Date'
                        class="bg-transparent rounded  text-light"
                        style="height:37px !important;width:120px !important;top: 7px;margin-inline-start:5px" 
                    ></DatePicker>
                    <Multiselect
                        v-else
                        ref="CreatedOnMultiSelect"
                        v-model="selectedCreatedDateValue"
                        :options="dateFieldFilterOptions"
                        placeholder=""
                        :searchable="true"
                        :close-on-select="true"
                        :allow-empty="false"
                        track-by="value_id"
                        label="value"
                        deselectLabel=""
                        selectLabel=""
                        selectedLabel=""
                        @select="updateDateTypeFilter('created_on',$event)"
                        style="margin-top: 7px;width: 140px;top:1px;">
                        <div slot="singleLabel" slot-scope="{ option }">
                            {{ option.value }}
                        </div>
                        <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                            <span style="margin-inline-start:12px;">{{ scope.option.value}}</span>
                        </div>
                        <span slot="noResult">No results.</span>
                    </Multiselect>
                    <div v-if="(selectedCreatedDateValue && 'value_id' in selectedCreatedDateValue && !['range','after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)) ||
                        (!selectedCreatedDateValue || !('value_id' in selectedCreatedDateValue) || !['range','after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id))" style="width:22px">
                        <svg v-if="(selectedCreatedDateValue && 'value_id' in selectedCreatedDateValue && !['range','after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id))" @click="selectedCreatedDateValue = {};fetchReportsQuery(true)"
                            width="2em" height="1.5em" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="bi bi-x" style="height: 30px; color: rgb(169, 169, 169); width: 30px;margin-inline-end: 3px;">
                            <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z">
                            </path>
                        </svg>
                        <svg v-else-if="!selectedCreatedDateValue || !('value_id' in selectedCreatedDateValue) || !['range','after_date','before_date','on_date'].includes(selectedCreatedDateValue.value_id)"
                         @click="focusMultiSelect('created_on')" xmlns="http://www.w3.org/2000/svg" style="margin-inline-end: 7px;" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="bi bi-caret-down-fill icon-background-on-hover">
                            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z">
                            </path>
                        </svg>
                    </div>
                </div> -->
                <div class="filters-main-wrapper" style="float:inline-start;margin: 5px;">
                    <div style="position:relative">
                        <input
                            type="text"
                            v-model="fileNameFilter"
                            class="bg-transparent rounded text-light w-100"
                            placeholder="Search by name..."
                            @keyup.enter="fetchReportsQuery(true);"
                            
                        />
                        <CancelIcon v-if="fileNameFilter.length > 0" @click="fileNameFilter = '',fetchReportsQuery()" style="position:absolute;inset-inline-end:1px;top:9px"></CancelIcon>
                    </div>
                    <div class="primary-btn-style justify-content-end"  style="padding: 0px !important;display:inline-block;margin: 0px !important;float:inline-start">
                        <button @click="fetchReportsQuery(true)" class="btn btn-outline-secondary m-2" style="width: 40px; margin: 0px 0px 0px 2px !important; padding:5px 4px 6px 4px;    border: 1px solid #4a4a4a;">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="h-100" style="padding-bottom: 14px;float:inline-end;">
                <div style="height:55px;border-bottom: 1px solid #1e1e1e;padding:8px 0px;" class="filter-fields-in-logs w-100">
                    <div class="primary-btn-style d-inline-flex" style="width: 100%;justify-content: end;padding-inline-end: 20px;">
                        <button class="btn btn-outline-primary m-2" style="margin:0px !important;" @click="openAddNewQueryBuilderDialog(null)">{{$t('Add Report')}}</button>
                    </div>
                </div>   
            </div>  
        </div>
        <div class="stage-reports-table">
            <table class="table table-with-border table-scroll small-first-col"  style="background: transparent">
                <thead style="color: #eee">
                    <tr>
                        <th style="width: 40%;padding-inline-start:9px !important;" class="text-left">{{$t('Name')}}</th>
                        <th style="width: 15%;">{{$t('Type')}}</th>
                        <!-- <th style="width: 24%">{{$t('Query Parameters')}}</th>
                        <th style="width: 20%;">{{$t('Columns Required')}}</th> -->
                        <th style="width: 15%;">{{$t('Created Date')}}</th>
                        <th style="width: 15%;">{{$t('Modified Date')}}</th>
                        <th style="width: 15%;">{{$t('Created By')}}</th>
                    </tr>
                </thead>
                <tbody v-if="reportsQueryList.length">
                    <tr v-for="eachQuery in reportsQueryList" @click="openAddNewQueryBuilderDialog(eachQuery)" :key="eachQuery._id" class="ccomm-asset-row show-download-icon" :class="{activeclass: activeIndex === eachQuery._id}">
                        <td class="text-left" style="position:relative;padding-inline-start: 9px !important;" :title="eachQuery.report_name">
                            <span v-if="'report_name' in eachQuery" class="text-ellipsis">{{eachQuery.report_name}}</span>
                            <span v-else> - </span>
                        </td>
                        <td class="text-center">
                            <span v-if="'report_type' in eachQuery">{{eachQuery.report_type}}</span>
                            <span v-else> - </span>
                        </td>
                        <!-- <td class="text-center">
                            <template v-if="'query_params' in eachQuery && Object.keys(eachQuery.query_params).length > 0">
                                <div>
                                    <div v-for="(value, key, index) in eachQuery.query_params" :key="key" style="word-break: break-all;">
                                        <template v-if="index <= 1">
                                            <template v-if="key == 'fields'">
                                                <div v-for="(feildValue, fieldKey, fieldIndex) in value" :key="fieldKey" style="word-break: break-all;" class="d-flex">
                                                    <template v-if="(Object.keys(eachQuery.query_params).length == 1 && fieldIndex <= 1) || (Object.keys(eachQuery.query_params).length > 1 && fieldIndex < 1)">
                                                        <span class="key-div">{{fetchMetadataFieldName(fieldKey)}}</span>
                                                        <div style="text-transform: capitalize;" class="ellipsis-to-entry">
                                                            {{fetchMetadataFieldValue(fieldKey, feildValue)}}
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>
                                            <div v-if="key != 'fields'" class="d-flex">
                                                <span class="key-div">{{key}}</span>
                                                <div v-if="Array.isArray(value)" style="text-transform: capitalize;" class="ellipsis-to-entry">
                                                    {{value.join(", ")}}
                                                </div>
                                                <div v-else style="text-transform: capitalize;" class="ellipsis-to-entry">
                                                    {{value}}
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <template v-if="eachQuery.query_params != undefined && shouldDisplayMore(eachQuery.query_params)">
                                        <div>+ {{$t('More')}}</div>
                                    </template>
                                </div>
                            </template>
                            <span v-else> - </span>
                        </td>
                        <td class="text-center">
                            <span v-if="'columns_required' in eachQuery && eachQuery.columns_required.length > 0">{{eachQuery.columns_required.join(", ")}}</span>
                            <span v-else> - </span>
                        </td> -->
                        <td class="text-center">
                            <span v-if="eachQuery.created_datetime && eachQuery.created_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(eachQuery.created_datetime)">{{checkIsTodayoryesterdayDate(eachQuery.created_datetime)?getDateAndTimeInConfiguredFormat(eachQuery.created_datetime, true):getDateAndTimeInConfiguredFormat(eachQuery.created_datetime)}}</span>
                            <span v-else> - </span>
                        </td>
                        <td class="text-center">
                            <span v-if="eachQuery.modified_datetime && eachQuery.modified_datetime.length > 0" :title="getDateAndTimeInConfiguredFormat(eachQuery.modified_datetime)">{{checkIsTodayoryesterdayDate(eachQuery.modified_datetime)?getDateAndTimeInConfiguredFormat(eachQuery.modified_datetime, true):getDateAndTimeInConfiguredFormat(eachQuery.modified_datetime)}}</span>
                            <span v-else> - </span>
                        </td>
                        <td class="text-center" :title="eachQuery.username" style="position:relative">
                            <span v-if="'username' in eachQuery">{{eachQuery.username}}</span>
                            <span v-else> - </span>
                            <div style="display:flex;position:absolute;top:0px;inset-inline-end:0px">
                                <svg v-if="(eachQuery.report_type == 'Assets' && (isUserTypeAdministrator() || (getLoggedInUserId() && eachQuery.user_id === getLoggedInUserId()))) || eachQuery.report_type != 'Assets'" @click.stop.prevent="donwloadReport(eachQuery)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-download parent-row-download" viewBox="0 0 16 16">
                                    <title>{{$t('Download Report')}}</title>
                                    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                                    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                                </svg>
                                <svg @click.stop.prevent="openAddNewQueryBuilderDialog(eachQuery)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-pencil parent-row-edit" viewBox="0 0 16 16">
                                    <title>{{$t('Edit')}}</title>
                                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                </svg>
                                <svg @click.stop.prevent="deleteQuery(eachQuery)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#eee" class="bi bi-trash parent-row-delete" viewBox="0 0 16 16">
                                    <title>{{$t('Delete')}}</title>
                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                </svg>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div>
            <Pagination
                v-model="currentPage"
                :records="totalAssets"
                :per-page="perPage"
                @paginate="paginate"
                :options="options"
            />
        </div>
        <addNewQueryModal v-if="showAddNewModal" @closeModal="closeModal" :selectedReport="selectedQueryInfo" :isEditContext="isEditContext"></addNewQueryModal>
    </div>
</template>

<script>
    import {mapActions,mapGetters, mapMutations} from "vuex";
    import Utils from '../../components.utils.js';
    import {NotifierConstants} from "../../components.constants.js";
    import Pagination from "vue-pagination-2";
    // import Multiselect from 'vue-multiselect';
    // import DatePicker from "vue2-datepicker";
    // import "vue2-datepicker/index.css";
    import addNewQueryModal from "./addNewQueryModal.vue";
    import UserMultiSelect from "../users/UserMultiselectField.vue";
    import CancelIcon from "../core/InlineCancelField.vue";

    export default {
        data(){
            return{
                reportsQueryList:[],
                showAddNewModal:false,
                isEditContext:false,
                totalAssets: -1,
                totalquries: -1,
                perPage: -1,
                options:{chunk:5},
                currentPage:1,
                fileNameFilter:'',
                activeIndex:null,
                selectedQueryInfo:null,
                customMetadataMapper:[],
                selectedUserInfo:null,
                selectedCreatedDateValue:{},
                createdOnFilter:null,
                dateFieldFilterOptions:[{"value": "Last one hour","value_id": "last_one_hr"},
                                        {"value": "Today","value_id": "today_date"},
                                        {"value": "Yesterday","value_id": "yesterday_date"},
                                        {"value": "Last week","value_id": "last_week"},
                                        {"value": "On","value_id": "on_date"},
                                        {"value": "Before","value_id": "before_date"},
                                        {"value": "After","value_id": "after_date"},
                                        {"value": "Range","value_id": "range"}],
            };
        },
        components:{
            "addNewQueryModal":addNewQueryModal,
            UserMultiSelect,
            Pagination,
            CancelIcon,
            // DatePicker,
            // Multiselect,
        },

        methods:{
            updateDateTypeFilter(key, value){
                if(['today_date', 'yesterday_date', 'last_week', 'last_one_hr'].includes(value.value_id)){
                    this.fetchReportsQuery(true)
                }else{
                    switch(value.value_id) {
                        case 'on_date':
                        case 'before_date':
                        case 'after_date':
                            setTimeout(() => {
                                if(key == "created_on"){
                                    this.createdOnFilter = null;
                                    if(this.$refs["createdOnNonRange"])this.$refs["createdOnNonRange"].focus();
                                }
                            }, 100);
                            break;
                        case 'range':
                            setTimeout(() => {
                                if(key == "created_on"){
                                    this.createdOnFilter = null;
                                    if(this.$refs["createdOn"])this.$refs["createdOn"].focus();
                                }
                            }, 100);
                            break;
                    }
                }
            },
            focusMultiSelect(key){
                switch(key){
                    case "created_on":
                        if(this.$refs['CreatedOnMultiSelect'])this.$refs["CreatedOnMultiSelect"].$el.focus();
                        break;
                    case "user-filters":
                        if(this.$refs['UserMultiSelect'])this.$refs["UserMultiSelect"].$el.focus();
                        break;
                    default:
                        break;
                }
            },
            isUserTypeAdministrator(){
                return Utils.isUserTypeAdmin(this.getLoggedInUserType());
            },
            handleUpdatedUsersList(user){
                if(user._id != "all"){
                    this.selectedUserInfo = user;
                   
                }else if(user._id == "all"){
                    this.selectedUserInfo = null
                }  
                
                 this.fetchReportsQuery(true); 
            },
            fetchMetadataFieldValue(fieldId, feildValue){
                let fieldInfo = this.customMetadataMapper.find(op=>op.custom_metadata_id == fieldId)
                if(fieldInfo && fieldInfo.values && fieldInfo.values.length > 0){
                    if(typeof(feildValue) == 'string'){
                        let pickVal = fieldInfo.values.find(op=>op.value_id == feildValue)
                        if(pickVal){
                            return pickVal.value;
                        }
                    }else if(Array.isArray(feildValue)){
                        return fieldInfo.values.filter(item => feildValue.includes(item.value_id)).map(item => item.value).join(", ");
                    }
                    return ' - '
                }
                return feildValue;
            },
            fetchMetadataFieldName(fieldId){
                let fieldInfo = this.customMetadataMapper.find(op=>op.custom_metadata_id == fieldId)
                if(fieldInfo){
                    return fieldInfo.name;
                }
                return ' - ';
            },
            shouldDisplayMore(queryParams){
                if(Object.keys(queryParams).length > 2 && !('fileds' in queryParams)){
                    return true;
                }
                else if('fields' in queryParams){
                    //only 'fields' key present in params, so directly length of it can be checked
                    if(Object.keys(queryParams).length == 1 && Object.keys(queryParams.fields).length > 2){
                        return true;
                    }
                    //if 'fields' key present then first check for index of the key
                    let indx = Object.keys(queryParams).indexOf('fields')
                    if(indx > 1){
                        //'fields' key present in 3rd position , hence we can show 'more' directly
                        return true;
                    }else if(indx <=1 && Object.keys(queryParams).length > 2){
                        //'fields' present in the first 2 keys. Also there are more keys in queryParams ,  hence we can show 'more' directly
                        return true;
                    }else if(indx <=1 && Object.keys(queryParams).length == 2){
                        //'fields' present in the first 2 keys. And no more keys in queryParams. SO check for 'fields' object keys length too
                        return (Object.keys(queryParams.fields).length > 2)

                    }

                }else if(Object.keys(queryParams).length > 2){
                    return true;
                }

                return false;
            },
            getValueForDisplay(queryValue){
                let displayValue = '-';
                if(queryValue){
                    if(typeof(queryValue) == 'string'){
                        displayValue = queryValue
                    }else{
                        displayValue = queryValue
                    }
                }
                return displayValue
            },

            openAddNewQueryBuilderDialog(queryData = null){
                if(queryData){
                    this.selectedQueryInfo = queryData;
                    this.isEditContext = true;
                }else{
                    this.isEditContext = false;
                }
                this.showAddNewModal = true;    
            },  

            closeModal(){
                this.showAddNewModal = false;
            },

            getAllQueryBuilderTypes(){
                // this.allTypesList =  
                this.getQueryBuilderTypesFromServer().then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.setQueryBUilderTypesInfo(data.report_types);
                    }else{
                        if(data.message){
                            this.$toast.error(data.message);
                        }
                    }    
                });
            },

            getQueryParamtersList(){
                this.getQueryParamtersListFromServer().then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.setQueryBuiderQueryParamters(data);
                    }else{
                        if(data.message){
                            this.$toast.error(data.message);
                        }
                    } 
                });
            },
            getColumnsRequired(){
                this.getColumneRequiredInQueryBuilder().then((data)=>{
                    if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.setColumnsRequiredInQueryBuilder(data.column_names);
                    }else{
                        if(data.message){
                            this.$toast.error(data.message);
                        }
                    } 
                });
            },
            deleteQuery(queryInfo){
                if (confirm(`Are You sure you want to delete the selected row?`)) {
                    let queryName = ""
                    if(queryInfo && 'report_name' in queryInfo){
                        queryName = queryInfo.report_name;
                    }
                    this.deleteQueryBuilds({_id:queryInfo._id}).then(data=>{
                        if (Utils.isAcceptedStatusCode(data.statusCode)){
                            if('message' in data){
                                this.$toast.info(data.message);
                            }else{
                                this.$toast.info(`${queryName} deleted successfully`);
                            }
                        }else{
                            this.$toast.error(data.message);
                        }
                    })
                }
            },
            donwloadReport(queryInfo){
                if(queryInfo && queryInfo._id){
                    this.$toast.info(this.$t("You will be notified once the report is ready to download"));
                    this.downloadQueryBasedReports({_id:queryInfo._id}).then(() => {
                        console.log("Downloading report")
                    })
                }else{
                    alert(this.$t("Please select valid query to download reports"))
                }
            },
            paginate(page){
                if(page){
                    this.fetchReportsQuery(false)
                }
            },
            getFilters(){
                let payloadParams = {page: this.currentPage}
                if(this.fileNameFilter && this.fileNameFilter.trim().length > 0){
                    payloadParams['report_name'] = this.fileNameFilter.trim()
                }
                if(this.selectedUserInfo && '_id' in this.selectedUserInfo){
                    payloadParams["user_id"] = this.selectedUserInfo._id
                }
                // Created on filter
                if(this.selectedCreatedDateValue && Object.keys(this.selectedCreatedDateValue).length >0 &&
                   'value_id' in this.selectedCreatedDateValue){
                    let CODateParams = null
                    switch(this.selectedCreatedDateValue.value_id) {
                        case 'today_date':
                            CODateParams =  {"type":"today_date"};
                            break;
                        case 'yesterday_date':
                            CODateParams =  {"type":"yesterday_date"};
                            break;
                        case 'last_week':
                            CODateParams =  {"type":"last_week"};
                            break;
                        case 'last_one_hr':
                            CODateParams =  {"type":"last_one_hr"};
                            break;
                        case 'on_date':
                            if(this.createdOnFilter && typeof this.createdOnFilter != "undefined" && this.createdOnFilter != null){
                                CODateParams = {type:this.selectedCreatedDateValue.value_id, value:this.createdOnFilter}
                            }
                            break;
                        case 'before_date':
                            if(this.createdOnFilter && typeof this.createdOnFilter != "undefined" && this.createdOnFilter != null){
                                CODateParams = {type:this.selectedCreatedDateValue.value_id, to_value:this.createdOnFilter}
                            }
                            break;
                        case 'after_date':
                            if(this.createdOnFilter && typeof this.createdOnFilter != "undefined" && this.createdOnFilter != null){
                                CODateParams = {type:this.selectedCreatedDateValue.value_id, from_value:this.createdOnFilter}
                            }
                            break;
                        case 'range':
                            if(this.createdOnFilter && typeof this.createdOnFilter != "undefined" && this.createdOnFilter != null &&
                               this.createdOnFilter.length == 2 && this.createdOnFilter[0] != null){
                                CODateParams = {type:"range", from_value: this.createdOnFilter[0], to_value: this.createdOnFilter[1]}
                            }
                            break;
                    }
                    if(CODateParams){
                        payloadParams['created_on'] = CODateParams
                    }
                }
                return payloadParams;
            },
            fetchReportsQuery(refreshed =false){
                if(refreshed){
                    this.currentPage = 1
                }
                let payload = {params:this.getFilters()}
                this.getQueryBuildsFromServer(payload).then(data=>{
                    if(data.reports){
                        this.reportsQueryList = data['reports'];
                        this.totalPages = data["page_count"];
                        this.currentPage = data["page"];
                        this.totalAssets = data["total_reports"];
                        this.perPage = data["reports_per_page"];
                        this.customMetadataMapper = data["custom_metadata_info"];
                    }
                })
            },
            handleNotification(notification){
                notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
                if(notification.message){
                    let queryInfo = notification.message;
                    if([NotifierConstants.dynamicQueryBuildDeletedNotification].includes(notification.message_type)){
                        let indx = this.reportsQueryList.findIndex(op=>op._id == queryInfo.report_id)
                        if(indx >= 0){
                            this.reportsQueryList.splice(indx,1);
                        }
                    }else if([NotifierConstants.dynamicQueryBuildCretedNotification].includes(notification.message_type)){
                        let indx = this.reportsQueryList.findIndex(op=>op._id == queryInfo._id)
                        if(indx < 0){
                            this.reportsQueryList.unshift(queryInfo);
                        }
                    }else if([NotifierConstants.dynamicQueryBuildModifiedNotification].includes(notification.message_type)){
                        let indx = this.reportsQueryList.findIndex(op=>op._id == queryInfo._id)
                        if(indx >= 0){
                            this.reportsQueryList[indx] = queryInfo;
                        }
                        if(this.selectedQueryInfo && this.selectedQueryInfo._id == queryInfo._id){
                            this.selectedQueryInfo = queryInfo;
                        }
                        this.$forceUpdate();
                    }
                }
            },
            ...mapActions("queryBuilder", ["getQueryBuilderTypesFromServer", "getQueryParamtersListFromServer", "getQueryBuildsFromServer", "downloadQueryBasedReports", "deleteQueryBuilds","getColumneRequiredInQueryBuilder"]),
            ...mapGetters("queryBuilder", ["getQueryBuiderTypes"]),
            ...mapMutations("queryBuilder", ["setQueryBUilderTypesInfo","setQueryBuiderQueryParamters","setColumnsRequiredInQueryBuilder"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapGetters("users", ["getLoggedInUserType",'getLoggedInUserId']),
        },
        created(){
            this.fetchReportsQuery(true);
            this.getAllQueryBuilderTypes();
            this.getQueryParamtersList();
            this.getColumnsRequired();
            this.addWSEventListener({eventname:[NotifierConstants.dynamicQueryBuildDeletedNotification, NotifierConstants.dynamicQueryBuildCretedNotification, NotifierConstants.dynamicQueryBuildModifiedNotification],callback:this.handleNotification,parent:"queryBuilder"})
        },
        beforeDestroy(){
            this.removeWSEventListener({eventname:[NotifierConstants.dynamicQueryBuildDeletedNotification, NotifierConstants.dynamicQueryBuildCretedNotification, NotifierConstants.dynamicQueryBuildModifiedNotification],callback:this.handleNotification,parent:"queryBuilder"})
        },
    }
</script>    


<style scoped lang="scss">
    $table-row-border: none;
    $active-blue: #007bff;
    $danger-color: #dc3545;
    $none-text-color:#4f4f4f;
    $add-button-text-color:#0b7099;
    $add-button-text-color-hover:#0193cc;
    $add-button-border-color:#b7b228;
    $add-button-border-on-hover:#dcd426;
    $add-button-backgroud:#1e1e1e;
    $active-green-color:#28a745;
    $primary-background: #1a1e21;
    $border-color: 1px solid #4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $highlight-font-color:#ff9800;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555; 
    $input-field-padding:.375rem 10px;
    $filter-border-color: #5a5a5a;
    $filter-bg-color: #2a2a2a;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $tags-background-color:#282d31;
    $svg-color:#666;
    $tags-border-color:#363636;
    $secondary-border-color: 1px solid #2b2b2b;
    $icon-hover:#2c3339;
    $input-field-and-label-font-size:14px;
    $input-field-height:22px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $applied-filter-background: #1c6c8e;
    $applied-filter-text-color: #eee;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;

    .jobs-info-icon{
        visibility:hidden;
    }

    .ccomm-asset-row:hover {
        .jobs-info-icon{
            visibility:visible;
        }
    }

    .ccomm-asset-row:hover{
        color: $active-blue;
    }

    .validationmessage{
        color:$danger-color;
    }

    .activeclass {
        color: $active-blue;
    }

    .modal-content {
        height: auto;
        min-height: 100%;
        border: 0 none;
        border-radius: 0;
        box-shadow: none;
        pointer-events: all;
        background: $primary-background !important;
    }

    .sidebar-menu {
        background: #857d7d !important;
    }
    .value-style {
        color: $text-color;
        width: 97%;
        text-align: start;
        padding-top: 3px;
        padding-bottom: 3px;
        padding-inline-end: 5px;
    }

    .filter-fields-in-asset div{
        display:inline-flex;
        div.comm-div{
            min-width: 255px;
            max-width: 294px;
            position: relative;
            margin: 5px;
            label{
                color: #757575;
                position: relative;
                inset-inline-end: 5px;
                width: 31%;
                text-align: start;
                top: 5px;
                inset-inline-start:6px;
            }
            select,input{
                width:70%;
                height:27px;
                border:$border-color !important;
            }
        }
    }
    .table-scroll {
        /*width:100%; */
        border: none !important;
        /* Decoration */
        border-spacing: 0;
        thead {
            color: $dull-text-color !important;
            position: relative;
            width: 100%;
            th{
                position: sticky;
                top: 0;
                background:$primary-background;
                z-index:9;
            }
        }
        tbody {
            width: 100%;
            overflow: auto;
            font-weight: 500;
            tr{
                height:60px;
            }
        }
    }

    .table{
        color:#fff !important;
        th{
            border-top:none !important;
            padding: 1rem !important;
        }
        td{
            border-top:none !important;
            padding: 0px !important;
            padding-inline-start: 2px !important;
        }
    }

    .table-with-border {
        thead {
            border-bottom: none;
        }
        tr {
            border-bottom: none;
        }
    }

    tbody tr{
        border-bottom: $secondary-border-color;
    }

    .comm-user-row:hover {
        color: $active-blue;
        td:first-child {
            text-decoration: underline;
        }
    }

    .stage-reports-table{
        height: calc(100% - 115px);
        overflow:auto;
    }
    .height-set-for-component {
        height: calc(100% - 170px);
    }

    .search-bar-comm-style {
        height: 30px;
        position: relative;
        input {
            border: $border-color !important;
            height: 38px !important;
            padding-inline-start: 8px;
        }
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }

    .activestatus {
        color: #28a745 !important;
    }

    .user-name-or-image{
        height: 30px;
        width: 30px;
        border: $border-color;
        border-radius: 10px;
        text-align: center;
        line-height: 28px;
        text-transform: uppercase;
        margin-top: 3px;
    }

    .user-name{
        margin-inline-end: 10px;
        position: relative;
        bottom: 7px;
    }
    
    input:focus{
        outline:none;
        box-shadow: none;
    }

    .dull-the-text{
        color: $secondary-text-color;
    }

    .text-ellipsis{
        white-space: nowrap; 
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis; 
        display: block;
        position: absolute;
    }
    .text-ellipsis:hover{
        text-decoration: underline
    }

    ::v-deep{
        .mx-input{
            background-color: $primary-background  !important;
            border: none !important;
            color: $text-color !important;
            height:100%;
        }
        .mx-input-wrapper{
            width:100%;
            height:100%;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color: $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:100%;
            height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            // border:$border-color !important;
            height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
            top:10px;
            inset-inline-end: 3px !important;
        }
    } 

    li {
        width: 25%;
        display: inline-flex;
        // margin-bottom: 20px;
    }

    .config-label {
        width: 26% !important;
        text-align: end;
        color: #757575;
        word-break: break-word;
        position: relative !important;
        top: 9px !important;
    }
    
    .config-value {
        margin-inline-start: 4px;
        width: 95% !important;
        display:grid;
        svg{
            position: relative;
            top: 9px;
            margin-inline-start: 10px;
        }
    }

    ::v-deep {
        .mx-input{
            background-color:$primary-background !important;
            border: none !important;
            color: #eee !important;
            height:100%;
        }
        .mx-input-wrapper{
            width:100%;
            height:100%;
        }
        .mx-datepicker-main{
            border: $border-color !important;
            background: $secondary-background-color !important;
        }
        .mx-calendar-content .cell:hover{
            background-color:  $bg-color-on-hover !important;
        }
        .mx-datepicker-range{
            width:100%;
            height:100% !important;
        }
        .mx-calendar-content .cell:hover {
            color: #000000;
            background-color: #7d99b1;
        }
        .mx-datepicker{
            width:100% !important;
            padding: 0 !important;
            // border:$border-color !important;
            height: 27px !important;
        }
        .mx-icon-calendar, .mx-icon-clear{
            color: #d7d2d280;
            top:10px;
            inset-inline-end: 3px !important;
        }
        .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float: inline-end;
            position: relative;
            margin-inline-start: 5px;
            top: 5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display: none;
        }
        .VuePagination__pagination-item-next-chunk {
            display: none;
        }

        .VuePagination__pagination-item-prev-page {
            width: 50px !important;
        }

        .VuePagination__pagination-item-next-page {
            width: 50px !important;
        }

        .VuePagination__pagination-item-next-page a:before {
            width: 50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after {
            width: 50px;
            content: " prev";
        }
        .v-list {
            padding: 0px !important;
        }
        .v-list-item {
            text-align: start;
            border: $secondary-border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title {
                font-size: 14px !important;
                color: $text-color !important;
            }
        }
        .v-menu__content {
            width: 190px !important;
        }
        .apply-background{
            .mx-input-wrapper{
                display: flex;
                justify-content: flex-start;
                padding-inline-start: 12px;
                background: $applied-filter-background !important;
                color: $applied-filter-text-color !important;
            }
            .mx-datepicker-range{
                .mx-input-wrapper{
                    padding-inline-start: 0px;
                }
            }
        }

        .catalog-filter{
            .multiselect{
                height:unset;
                min-height:30px;
                width:100% !important;
            }
        }
        .apply-background{
            background: $applied-filter-background !important;
            color: $applied-filter-text-color !important;
            border: 1px solid #229ed2 !important;
            .comm-input-field-style,.selected-tags-style, .multiselect__input{
                background: $applied-filter-background !important;
                color: $applied-filter-text-color !important;
            }
            .multiselect__tags, .mx-input{
                background: $applied-filter-background !important;
            }
            .multiselect__single, .mx-input, .mx-icon-calendar, .mx-icon-clear, button, svg{
                color: $applied-filter-text-color !important;
            }
            .remove-tag{
                svg{
                    color: $applied-filter-text-color !important;
                }
            }
            .multiselect__select::before{
                visibility:hidden;
                display: none;
                border-color: #b8b8b8 transparent transparent !important;
            }
            .multiselect__placeholder, ::placeholder {
                color: #a6a6a6  !important;
            }
            svg{
                fill: #bababa
            }
        }
    
        .apply-background:hover{
            svg{
                fill: #eee;
            }
        }
        .multiselect__select{
            visibility:hidden;
            display: none;
            height: 30px;
        }

        .multi-tags-select, .single-selection{
            .multiselect__select::before{
                visibility:hidden;
                display: none;
                top:65%;
            }
        }

        .add-search-filter{
            display: inline-flex;
            border: 3px solid $border-color-only !important;
            .add-fileds-icon{
                position: absolute;
                inset-inline-start:10px;
                z-index: 99;
                top: 13px;
            }
            .multiselect{
                min-width:15%;
                margin: -2px 0px;
                .multiselect__tag{
                    display:none;
                }
                .multiselect__select{
                    display:none;
                }
            }
        }
        .multiselect{
                width:100%;
                margin: 3px 0px;
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
            color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
            color:$secondary-text-color !important;
            font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            padding: 1px 40px 0 8px;
        }
        .multiselect__placeholder {
            padding-top: 4px !important;
            margin-bottom:0px;
            color:#5d5d5d !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 30px;
        }
        .multiselect__single{
            padding-top:3px !important;
            margin-bottom: 6px;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: fixed;
            display: block;
            background: $text-color;
            width: 18%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
            background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background !important;
            height: auto;
            min-height: 30px;
        }
        .add-search-filter{
            .multiselect__tags {
                min-height: 29px;
            }
        }
        .filter-wrapper{
            height:38px;
            display:inline-flex;
            align-items: center;
            border: $border-color;
            border-radius: 5px;
            background: $primary-background ;
            color:$dull-text-color;
            // height:35px;
            .filter-label{
                margin:0px 4px;
                width: auto;
                white-space: nowrap;
                padding-inline-start:4px;
            }
            .comm-input-field-style,.multiselect__tags{
                border: none !important;
                border-radius: none !important;
            }
            .mx-input{
                height:22px;
                padding: 6px 21px !important;
                padding-inline-start: 0px !important;
            }
            .multiselect{
                margin:0px !important;
            }
        }
    }
    .filters-main-wrapper{
        width:100%;
        float: inline-start;
    }
    .download-button{
        padding: 0px !important;
        width: 5% !important;
        float: inline-end;
        border: 1px solid rgb(88, 88, 88);
        display: inline-flex;
        align-items: center;
        justify-content: center !important;
        border-radius: 4px;
        margin: 5px;
        height: 38px;
    }

    /* width */
    ::-webkit-scrollbar {
        width: 8px;
    }
    
    /* Track */
    ::-webkit-scrollbar-track {
        background: $scrollbar-track-background;
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $scrollbar-thumb-background;
    }
    
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $scrollbar-thumb-on-hover-background;
    }
    .show-download-icon:hover{
        position: relative;
        .parent-row-delete, .parent-row-edit, .parent-row-download{
            visibility: visible;
        }
    }

    .parent-row-delete, .parent-row-edit, .parent-row-download{
        z-index: 1;
        background: #525252;
        border: 1px solid #262626;
        width: 55px;
        height: 44px;
        padding: 12px;
        top: 0px;
        border-radius: 4px;
        visibility: hidden;
        color: #fff;
    }
    .key-div{
        color: #757575;
        padding-inline-end: 5px;
    }
    .filter-wrapper{
        height:38px !important;
        display:inline-flex;
        align-items: center;
        border: $border-color;
        border-radius: 5px;
        background: $primary-background ;
        color:$dull-text-color;
        // height:35px;
        .filter-label{
            margin:0px 4px;
            width: auto;
            white-space: nowrap;
            padding-inline-start:4px;
        }
        .comm-input-field-style,.multiselect__tags{
            border: none !important;
            border-radius: none !important;
        }
        .mx-input{
            height:22px;
            padding: 6px 21px !important;
            padding-inline-start: 0px !important;
        }
        .multiselect{
            margin:0px !important;
        }
    }
</style>